import { IStyles } from '../models/app/IStyles';

export const STYLES: IStyles = {
	components: {
		app: {
			background: {
				color: '#FAFAFA',
			},
			children: {
				wrapper: {

				},
				tile: {
					border: {
						bottom: {

							style: 'solid',
							width: '1px',
							color: '#E0E3ED',
						},
					},
					margin: {
						bottom: '36px',
					},
					padding: {
						_value: '5px',
						left: '15px',
						bottom: '36px',
					},
				},
			},
		},
		resetPassword: {
			overrides: [
				{
					selector: '[data-selector="base-buttonRaised"]',
					style: {
						// background: {
						// 	color: '#d40000',
						// },
						margin: {
							_value: '0 0',
						},
					},
				},
			],
		},
		userDetail: {
			overrides: [
				{
					selector: '[data-selector="base-buttonRaised"]',
					style: {
						// background: {
						// 	color: '#d40000',
						// },
						margin: {
							_value: '0 0',
						},
					},
				},
			],
		},
		assurance: {
			overrides: [
				{
					selector: '[data-selector="base-buttonRaised"]',
					style: {
						// background: {
						// 	color: '#d40000',
						// },
						margin: {
							_value: '0 0',
						},
					},
				},
				{
					selector: '[data-selector="message-infoMessage"][data-qa-ref="assuranceMessageRemainingCharacters"]',
					style: {
						margin: {
							_value: '0 0',
							top: '-20px',
							bottom: '20px',

						},
						text: {
							align: 'left',
						},
					},
				},
				{
					selector: '[data-selector="base-imagePicker-wrapper"]',
					style: {
						margin: {
							left: '0',
							bottom: '20px',
						},
					},
				},
			],
		},
		mfaSetup: {
			children: {
				row: {
					display: 'flex',
					flex: {
						direction: 'row',
					},
					padding: {
						top: '8px',
						bottom: '8px',
						left: '20px',
						right: '20px',
					},
					selectors: {
						':nth-child': {
							_parameters: ['2'],
							background: {
								color: 'rgb(243, 244, 248);',
							},
						},
					},
				},
				rowText: {
					display: 'flex',
					flex: {
						_value: '1',
					},
				},
				rowButtonWrapper: {
					display: 'flex',
				},
				clickText: {
					border: {
						_value: '0',
					},
					background: {
						_value: 'none',
					},
					color: 'rgb(19, 117, 241)',
					font: {
						size: '12px',
						weight: '400',
					},
				},
				mfaMethodWrapper: {
					padding: {
						_value: '15px',
					},
				},
				activeMfaMethodWrapper: {
					box: {
						shadow: '0px 0px 1px rgba(43, 43, 43, 0.5)',
					},
					background: {
						color: 'white',
					},
					padding: {
						_value: '15px',
					},
				},
			},
		},
		mfaSetupPush: {
			overrides: [
				{
					selector: '[data-selector="base-buttonRaised"]',
					style: {
						background: {
							color: '#d40000',
						},
						margin: {
							_value: '0 0',
						},
					},
				},
			],
			children: {
				wrapper: {
					text: {
						align: 'center',
					},
				},
			},
		},
		mfaSetupText: {
			children: {
				loadingWrapper: {
					text: {
						align: 'center',
					},
				},
				buttons: {
					text: {
						align: 'center',
					},
				},
			},
		},
		mfaSetupCall: {
			children: {
				loadingWrapper: {
					text: {
						align: 'center',
					},
				},
			},
		},
		phoneNumber: {
			children: {
				wrapper: {
					display: 'flex',
					flex: {
						wrap: 'wrap',
						direction: 'row',
					},
					justifyContent: 'center',
					padding: {
						top: '10px',
						bottom: '10px',
					},
				},
			},
		},
		impersonation: {
			children: {
				impersonateUserRow: {
					width: '100%',
					outline: {
						style: 'none',
					},
					display: 'flex',
					font: { family: '"DM Sans", sans-serif' },
					justifyContent: 'space-between',
				},
				impersonateUserRowButton: {
					background: {
						color: '#1373f1',
					},
					font: {
						family: '"DM Sans", sans-serif',
						size: '13px',
						weight: '400',
					},
					color: 'white',
					height: '20px',
					padding: {
						_value: '0px 10px',
						top: '4px',
						bottom: '4px',
					},
					border: {
						width: 'initial',
						_value: 'none',
					},
					margin: {
						_value: 'auto 0px',
					},
					outline: {
						_value: 'none',
					},
				},
				impersonateUserRowLabel: {
					padding: {
						top: '5px',
					},
				},
				impersonateUserListHeadingLabel: {
					top: '14px',
					position: 'relative',
				},
			},
			overrides: [
				{
					selector: '[data-selector="base-list-placeholder"]',
					style: {
						padding: {
							top: '14px',
						},
					},
				},
				{
					selector: 'ul',
					style: {
						listStyle: {
							type: 'none',
						},
						padding: {
							left: '0px',
						},
					},
				},
				{
					selector: 'li',
					style: {
						padding: {
							left: '20px',
						},
					},
				},
				{
					selector: 'li:nth-child(odd)',
					style: {
						background: {
							color: '#f3f4f8',
						},
					},
				},
				{
					selector: 'li:hover',
					style: {
						background: {
							_value: '#1a80ff',
						},
					},
				},
				{
					selector: '[data-selector="base-list-multipartListItem"]',
					style: {
						display: 'flex',
					},
				},
				{
					selector: '[data-selector="base-list-firstContent"]',
					style: {
						padding: {
							top: '10px',
						},
					},
				},
				{
					selector: '[data-selector="base-list-lastContent"]',
					style: {
						position: 'absolute',
						right: '50px',
					},
				},
				{
					selector: '[data-selector="base-list-multipartListItem"]',
					style: {
						height: '38px',
					},
				},
				{
					selector: '[data-qa-ref="searchLabel"]',
					style: {
						width: '90%',
						font: {
							size: '13px',
							weight: '400',
						},
						color: '#4a4a4a',
						margin: {
							_value: '0px 0px 1em',
						},
					},
				},
				{
					selector: '[data-selector="base-paging-wrapper"]',
					style: {
						display: 'flex',
						justifyContent: 'flex-end',
						font: { family: '"DM Sans", sans-serif' },
						background: {
							color: '#f3f4f8',
						},
						border: {
							width: '1px',
							style: 'solid',
							_value: '#d6d9e1',
						},
					},
				},
				{
					selector: '[data-selector="base-paging-pageBackwards"]',
					style: {
						width: '35px',
					},
				},
				{
					selector: '[data-selector="base-paging-pageForwards"]',
					style: {
						width: '35px',
					},
				},
				{
					selector: '[data-selector="base-paging-pagingResultsStatus"]',
					style: {
						padding: {
							top: '10px',
						},
					},
				},
				{
					selector: '[data-selector="base-input"]',
					style: {
						padding: {
							left: '40px',
						},
					},
				},
			],
		},
	},
	theme: {
		base: {
			search: {
				children: {
					wrapper: {
						overrides: [
							{
								selector: '[data-selector="base-search-searchIcon"]',
								style: {
									position: 'absolute',
									padding: {
										_value: '8px',
									},
								},
							},
							{
								selector: '[data-selector="base-input"]',
								style: {
									padding: {
										left: '40px',
									},
									width: '100%',
								},
							},
							{
								selector: '[data-selector="base-search-searchIcon"]',
								style: {
									position: 'absolute',
									padding: {
										_value: '8px',
									},
								},
							},
							{
								selector: '[data-selector="base-search-searchClear"]',
								style: {
									position: 'absolute',
									padding: {
										_value: '8px',
									},
									right: '15px',
								},
							},
						],
					},
				},
			},
			paging: {
				children: {
					wrapper: {
						overrides: [
							{
								selector: '[data-selector="base-buttonFlat"]',
								style: {
									outline: {
										style: 'none',
									},
								},
							},
						],
					},
				},
			},
			card: {
				children: {
					title: {
						font: {
							size: '24px',
							weight: 'normal',
						},
						lineHeight: '30px',
						color: '#3A4051',
					},
					subtitle: {
						font: {
							size: '14px',
							weight: 'normal',
						},
						lineHeight: '18px',
						color: '#69748E',
					},
				},
			},
			checkbox: {
				children: {
					icon: {
						verticalAlign: 'middle',
					},
				},
			},
			labelledInput: {
				margin: {
					bottom: '25px',
				},
				children: {
					labelComponent: {
						display: 'block',
						font: {
							size: '11px',
						},
						lineHeight: '14px',
						color: '#B0B8CB',
					},
					inputComponent: {
						display: 'block',
						font: {
							size: '13px',
						},
						width: '300px',
						background: {
							_value: 'none',
						},
						border: {
							_value: 'none',
							bottom: {
								width: '1px',
								style: 'solid',
								color: '#C3C9D9',
							},
						},
						selectors: {
							':focus': {
								border: {
									_value: 'none',

									bottom: {
										width: '2px',
										style: 'solid',
										color: '#4068B0',
									},
								},
							},
						},
					},
				},
			},
			application: {
				font: {
					family: '"DM Sans", sans-serif',
					size: '13px',
					weight: '400',
				},
			},
			button: {
				cursor: 'pointer',
				lineHeight: '24px',
				border: {
					width: '0',
				},
				background: {
					_value: 'none',
				},
				font: {
					weight: '400',
					family: '"DM Sans", sans-serif',
					size: '13px',
				},
				padding: {
					_value: '4px',
				},
				color: 'inherit',
			},
			buttonFlat: {
				box: { sizing: 'inherit' },
				font: {
					weight: '400',
					size: '13px',
					family: '"DM Sans", sans-serif',
				},
				display: 'flex',
				flex: { shrink: '0' },
				justifyContent: 'center',
				align: { items: 'center' },
				cursor: 'pointer',
				border: {
					width: '0px',
					style: 'initial',
					color: 'initial',
				},
				background: {
					_value: 'none',
				},
				margin: {
					_value: '0px auto',
				},
				padding: {
					_value: '5px 10px',
				},
				overrides: [
					{
						selector: 'img[data-selector="base-icon"]',
						style: {
							margin: {
								right: '4px',
							},
						},
					}]
				,
			},
			buttonRaised: {
				box: {
					sizing: 'inherit',
					shadow: 'rgba(0, 33, 121, 0.05) 0px 6px 12px, rgba(0, 20, 74, 0.07) 0px 0px 4px',
				},
				font: {
					weight: '400',
					size: '11px',
				},
				display: 'flex',
				flex: {
					shrink: '0',
				},
				justifyContent: 'center',
				align: {
					items: 'center',
				},
				cursor: 'pointer',
				lineHeight: '24px',
				border: {
					width: '0px',
					style: 'initial',
					color: 'initial',
				},
				color: 'rgb(255, 255, 255)',
				position: 'relative',
				width: 'auto',
				background: {
					color: '#4068B0',
				},
				padding: {
					_value: '10px 30px',
				},
				selectors: {
					':disabled': {
						background: {
							color: '#939799',
						},
						cursor: 'no-drop',
					},
				},
				margin: {
					_value: '10px auto',
				},
			},
			confirmDialog: {
				children: {
					wrapper: {
						width: '35vw',
					},
					header: {
						color: 'rgb(58, 64, 81)',
						font: {
							size: '22px',
							weight: '400',
						},
						lineHeight: '32px',
					},
					message: {
						color: 'rgba(58, 64, 81, 0.6)',
						font: {
							size: '16px',
						},
					},
					buttonContainer: {
						display: 'flex',
						justifyContent: 'flex-end',
						padding: {
							bottom: '10px',
						},
						text: {
							align: 'right',
						},
					},
					confirmButton: {
						color: 'rgb(26, 128, 255)',
						font: {
							size: '13px',
							weight: '500',
						},
						margin: {
							_value: '0',
						},
						selectors: {
							':hover': {
								background: {
									color: 'rgb(243, 244, 248)',
								},
							},
							':focus': {
								outline: {
									color: 'none',
									style: 'none',
								},
								box: {
									shadow: 'none',
								},
							},
						},
					},
					cancelButton: {
						color: 'rgb(26, 128, 255)',
						font: {
							size: '13px',
							weight: '500',
						},
						margin: {
							_value: '0',
						},
						selectors: {
							':hover': {
								background: {
									color: 'rgb(243, 244, 248)',
								},
							},
							':focus': {
								outline: {
									color: 'none',
									style: 'none',
								},
								box: {
									shadow: 'none',
								},
							},
						},
					},
				},
			},
			dialog: {
				children: {
					backdrop: {
						content: '',
						display: 'block',
						position: 'absolute',
						background: {
							color: 'rgba(0, 0, 0, 0.5)',
						},
						left: '0',
						top: '0',
						margin: {
							_value: '-50vmax',
						},
						bottom: '0',
						right: '0',
					},
					base: {
						background: {
							color: 'white',
						},
						display: 'flex',
						flex: {
							direction: 'column',
						},
						zIndex: '99',
						transition: {
							_value: 'all 0.2s',
						},
						position: 'absolute',
						top: '50%',
						left: '50%',
						margin: {
							_value: 'auto',
						},
						transform: 'translate(-50%, -50%)',
						max: {
							height: 'calc(100% - 60px)',
							width: 'calc(100% - 60px)',
						},
					},
					body: {
						padding: {
							_value: '0 15px',
						},
					},
				},
			},
			iconInput: {
				children: {
					wrapper: {
						position: 'relative',
						width: '340px',
						max: {
							width: '100%',
						},
						margin: {
							_value: '10px auto',
						},
					},
					inputComponent: {
						box: {
							sizing: 'border-box',
						},
						width: '100%',
						height: '40px',
						background: {
							color: '#f3f4f8',
						},
						outline: {
							width: '0',
							style: 'none',
						},
						font: {
							size: '13px',
							weight: '400',
						},
						lineHeight: '1',
						padding: {
							_value: '0 3em',
						},
						selectors: [
							{
								':focus': {
									border: {
										width: '2px',
										style: 'solid',
										color: '#1a80ff',
									},
								},
								'::placeholder': {
									color: '#a9a9a9',
								},
							},
						],
					},
					standardWrapper: {
						overrides: [
							{
								selector: 'input',
								style: {
									border: {
										width: '2px',
										style: 'solid',
										color: 'transparent',
										radius: '1px',
									},
									selectors: {
										':focus': {
											border: {
												width: '2px',
												style: 'solid',
												color: '#1a80ff',
											},
										},
									},
								},
							},
						],
					},
					errorWrapper: {
						overrides: [
							{
								selector: 'input',
								style: {
									border: {
										width: '2px',
										style: 'solid',
										color: '#ff7449',
										radius: '1px',
									},
									selectors: {
										':focus': {
											border: {
												width: '2px',
												style: 'solid',
												color: '#ff7449',
											},
										},
									},
								},
							},
						],
					},
					iconWrapper: {
						position: 'absolute',
						display: 'flex',
						top: '50%',
						transform: 'translateY(-50%)',
						left: '0.75em',
					},
					iconComponent: {
						fill: 'none',
					},
				},
			},
			input: {
				box: {
					sizing: 'border-box',
				},
				height: '40px',
				background: {
					color: '#f3f4f8',
				},
				outline: {
					width: '0',
					style: 'none',
				},
				font: {
					size: '13px',
					weight: '400',
				},
				lineHeight: '1',
				padding: {
					_value: '0 4px',
				},
				selectors: [
					{
						':focus': {
							border: {
								width: '2px',
								style: 'solid',
								color: '#1a80ff',
							},
						},
						'::placeholder': {
							color: '#a9a9a9',
						},
					},
				],
			},
			dropdown:
			{
				children: {
					header: {
						border: {
							bottom: {
								width: '2px',
								style: 'solid',
								color: '#0075BE',
							},
						},
						position: 'relative',
						display: 'inline-block',
						lineHeight: '37px',
						padding: {
							left: '5px',
						},
						font: {
							weight: 'bold',
						},
					},
					headerTitle: {
						float: 'left',
					},
					headerIcon: {
						float: 'right',
						position: 'relative',
						top: '10px',
					},
					listItems: {
						position: 'absolute',
						background: {
							color: '#FFF',
						},
						zIndex: '1000',
						listStyle: {
							type: 'none',
						},
						display: 'inline-block',
						width: '25%',
						margin: {
							_value: '0',
						},
						padding: {
							_value: '0',
						},
					},
					listItem: {
						padding: {
							bottom: '5px',
							top: '5px',
							left: '5px',
						},
						selectors: {
							':hover': {
								background: {
									color: '#0075BE',
								},
								color: '#FFF',
							},
						},
						border: {
							bottom: {
								_value: '1px solid #D9DCE1',
							},
						},
					},
					clickLayer: {
						zIndex: '999',
						position: 'absolute',
						top: '0',
						bottom: '0',
						left: '0',
						right: '0',
						background: {
							color: 'transparent',
						},
					},
				},
			},
			heading: {
				children: {
					h1: {
						color: '#d6d9e1',
						font: {
							size: '15px',
							weight: 'bold',
						},
						max: {
							width: '65%',
						},
						padding: {
							right: '0px',
						},
						text: {
							align: 'center',
						},
						margin: {
							_value: '0px auto 10px',
						},
					},
				},
			},
			imagePicker: {
				children: {
					wrapper: {
						position: 'relative',
						margin: {
							top: '15px',
							left: 'auto',
							right: 'auto',
						},
						width: '200px',
						height: '160px',
						flex: {
							shrink: '0',
						},
						box: {
							sizing: 'content-box',
						},
						border: {
							_value: '1px solid #d6d9e1',
						},
						background: {
							color: '#f3f4f8',
						},
					},
					coveringButton: {
						cursor: 'pointer',
						position: 'absolute',
						width: '100%',
						height: 'inherit',
						top: '0',
						left: '0',
						right: '0',
						bottom: '0',
						display: 'flex',
						justifyContent: 'flex-start',
						padding: {
							_value: '0px',
						},
					},
					buttons: {
						position: 'relative',
						flex: {
							grow: '1',
						},
					},
					toggleButton: {
						cursor: 'pointer',
						position: 'relative',
						display: 'inline-block',
						justifyContent: 'center',
						align: {
							items: 'center',
						},
						width: '100%',
						top: '50%',
						transform: 'translateY(-50%)',
						border: {
							width: '0px',
							style: 'initial',
							color: 'initial',
							image: {
								_value: 'initial',
							},
						},
						background: {
							_value: 'none',
						},
						padding: {
							_value: '0',
						},
						margin: {
							_value: '0',
						},
					},
					refreshButton: {
						cursor: 'pointer',
						display: 'inline-block',
						justifyContent: 'center',
						align: {
							items: 'center',
						},
						width: '100%',
						border: {
							width: '0px',
							style: 'initial',
							color: 'initial',
							image: {
								_value: 'initial',
							},
						},
						background: {
							_value: 'none',
						},
						padding: {
							_value: '0',
						},
						margin: {
							_value: '0',
							top: '20px',
						},
					},
					selectedImage: {
						height: 'inherit',
						position: 'relative',
						border: {
							radius: '0px',
						},
					},
					pickerOverlay: {
						position: 'absolute',
						top: '-1px',
						left: '-1px',
						width: '360px',
						height: '240px',
						box: {
							shadow: 'rgba(0, 33, 121, 0.05) 0px 6px 12px, rgba(0, 20, 74, 0.07) 0px 0px 4px',
						},
						zIndex: '1',
						display: 'flex',
						background: {
							color: '#f3f4f8',
						},
						border: {
							_value: '1px solid #d6d9e1',
							image: {
								_value: 'initial',
							},
						},
					},
					thumbnails: {
						width: '320px',
						position: 'relative',
						height: '100%',
						overflow: {
							y: 'auto',
						},
						display: 'flex',
						flex: {
							wrap: 'wrap',
						},
						justifyContent: 'flex-start',
						box: {
							sizing: 'border-box',
						},
						background: {
							color: 'white',
						},
					},
					thumbnail: {
						cursor: 'pointer',
						width: 'calc(100% / 3)',
						height: '107px',
						padding: {
							_value: '0px',
						},
					},
					thumbnailImage: {
						width: '100%',
						position: 'relative',
						border: {
							radius: '0px',
						},
					},
				},
			},
		},
		message: {
			base: {
				text: {
					align: 'center',
				},
				font: {
					family: '"DM Sans", sans-serif',
					weight: 'normal',
					size: '13px',
				},
				max: {
					width: ' 65%',
				},
				color: '#33da94',
				margin: {
					_value: '0px auto',
				},
				padding: {
					right: '0px',
				},
			},
			errorMessage: {
				color: 'rgb(255, 116, 73)',
			},
			infoMessage: {
				color: '#D6D9E1',
			},
			successMessage: {
				color: '#33da94',
			},
		},
	},
};